import request from "@/utils/request.js";
class Api {
  // 登录
  login(data) {
    return request({
      method: "post",
      url: "/login",
      data,
    });
  }
  // 退出
  logout() {
    return request({
      url: "/user/login_out",
      method: "post",
    });
  }
  // 用户信息
  userInfo() {
    return request({
      url: "/user/info",
      method: "get",
    });
  }
  // 上传文件
  uploadFile(data) {
    return request({
      url: "/user/upload",
      method: "post",
      data,
      timeout: 0,
    });
  }
}
export default new Api();
